import * as React from "react";
import { Box, Paper, Typography, TextField, Button } from "@mui/material";
import { supabase } from "../../logic/client";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { IconButton, InputAdornment } from "@mui/material";


export default function ResetPassword(props: { handlePageChange: (page: string) => void }) {
  const [password, setPassword] = React.useState("");
  const [confirm, setConfirm] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [state, setState] = React.useState<"idle" | "loading" | "ok" | "error">("idle");
  const [error, setError] = React.useState<string | null>(null);

  const token = new URLSearchParams(window.location.search).get("token");

  const submit = async () => {
    setError(null);

    if (!token) {
      setError("Ungültiger oder fehlender Token.");
      return;
    }

    if (!password || password.length < 8) {
      setError("Passwort muss mindestens 8 Zeichen haben.");
      return;
    }

    if (password !== confirm) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }

    setState("loading");

    const { data, error } = await supabase.functions.invoke("reset-password", {
      body: {
        token,
        new_password: password,
      },
    });

    if (error || !data?.ok) {
      setState("error");
      setError("Passwort konnte nicht zurückgesetzt werden.");
      return;
    }

    // Clean URL (remove token)
    window.history.replaceState({}, "", "/reset-password");

    setState("ok");
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "#F3F4F6", p: 2 }}>
      <Paper sx={{ p: { xs: 3, sm: 4 }, width: "100%", maxWidth: 420, borderRadius: 3 }}>
        {state !== "ok" && (
          <>
            <Typography fontWeight={900} mb={1}>
              Neues Passwort setzen
            </Typography>

            <TextField
                type={showPassword ? "text" : "password"}
                label="Neues Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                edge="end"
                                onClick={() => setShowPassword((s) => !s)}
                                aria-label={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />

            <TextField
                type={showPassword ? "text" : "password"}
                label="Passwort bestätigen"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                fullWidth
                sx={{ mb: 2 }}
            />

            {error && (
              <Typography color="error" fontWeight={700} mb={1}>
                {error}
              </Typography>
            )}

            <Button
              variant="contained"
              fullWidth
              disabled={state === "loading"}
              onClick={submit}
            >
              Passwort speichern
            </Button>
          </>
        )}

        {state === "ok" && (
          <>
            <Typography fontWeight={900}>Passwort aktualisiert 🎉</Typography>
            <Typography sx={{ mt: 1 }}>
              Sie können sich jetzt anmelden.
            </Typography>

            <Button
              sx={{ mt: 2 }}
              variant="contained"
              onClick={() => props.handlePageChange("Entry")}
            >
              Zur Anmeldung
            </Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
